import dtuIcon from '../assets/dtu_icon.svg'
import dtuWordmark from '../assets/dtu_wordmark.svg'
import gcIcon from '../assets/gc_icon.webp'
import gcWordmark from '../assets/gc_wordmark.webp'

/** Key the resolved trading house is cached under, shared by every reader and writer. */
export const TRADING_HOUSE_STORAGE_KEY = 'tradingHouse'

type TradingHouseBranding = {
  icon: string
  wordmark: string
  name: string
}

const BRANDING: Record<string, TradingHouseBranding> = {
  greenchart: { icon: gcIcon, wordmark: gcWordmark, name: 'GreenChart' },
  gtf: { icon: dtuIcon, wordmark: dtuWordmark, name: 'Day Trade U' },
}

/** Logo set for a trading house, falling back to GreenChart for an unknown house. */
export function brandingForTradingHouse(tradingHouse?: string | null): TradingHouseBranding {
  return (tradingHouse && BRANDING[tradingHouse]) || BRANDING.greenchart
}

/**
 * Trading house the previous session resolved to. The loading screen paints before
 * usermeta loads, so this cached value is the only house hint available to it.
 */
export function lastKnownTradingHouse(): string | null {
  return localStorage.getItem(TRADING_HOUSE_STORAGE_KEY)
}
